import { createVar, keyframes, style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const skelWidth = createVar();
export const skelHeight = createVar();
export const skelBorderRadius = createVar();

const pulse = keyframes({
  "0%": { opacity: 1 },
  "50%": { opacity: 0.6 },
  "100%": { opacity: 1 },
});

export const skeletonStyles = style({
  display: "flex",
  borderRadius: skelBorderRadius,
  backgroundColor: vars.colors.tonal,
  width: skelWidth,
  height: skelHeight,
  animation: `${pulse} 1.2s ease-in-out infinite`,

  "@media": {
    "(prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
});
